// export const BaseURL = "http://localhost:8081";
// export const BaseURL = "https://i.tysoft.com/";
// export const BaseURL = "https://mobile.softlake.com/api";
export const BaseURL = "https://mobile.wanhetianyi.cn/api";
// export const BaseURL = "https://crm.apearth.com/";
